import { REST_API_SERVER, NODE_API_SERVER } from '../util/constants'
import { GetCORSRaw } from '../util/netUtil'
/*
 * Encryption routines
 *
 */

const crypto = require('crypto');
const algorithm = 'aes-256-cbc';
//const algorithm = 'aes-128-cbc';
//const CBC_BLOCK_SIZE = 16;

/*
// padding the end of string with the number of pad chars
function pad(data) {
    var pad_size = CBC_BLOCK_SIZE - (data.length % CBC_BLOCK_SIZE)
    console.log("pad: count="+pad_size)
    return data + String.fromCharCode(pad_size).repeat(pad_size)
}
*/

// expect all input as string (not Buffer)
export function encrypt(text, key, iv) {
    let cipher = crypto.createCipheriv(algorithm, key, iv);

    // cipher always returns Buffer type
    let bencrypted = cipher.update(text, 'utf8', 'hex') + cipher.final('hex');
    console.log('bencrypted: ', bencrypted, bencrypted.length)
    return bencrypted;
}

// expect text in object
export function decrypt(text, key) {
    let iv = Buffer.from(text.iv, 'hex');
    let encryptedText = Buffer.from(text.data, 'hex');

    let decipher = crypto.createDecipheriv(algorithm, key, iv);
    let decrypted = decipher.update(encryptedText);

    decrypted = Buffer.concat([decrypted, decipher.final()]);
    return decrypted.toString();
}

/* TEST CODE
const key1 = crypto.randomBytes(32);
const iv1 = crypto.randomBytes(16);
var hw = encrypt("Some serious stuff", key1, iv1)
console.log(hw);
console.log("DECRYPT TEST: "+decrypt(hw, key1));
/**/




/*
 * authenticate user to get server-signed access token
 */
export function UserAuth(auth_token) {
    
    var result=fetch(REST_API_SERVER+"/authenticate/", {
          method: "GET",
          headers: {
              "accept": "application/json",
              "Access-Control-Allow-Origin": "*",
              "Authorization": `JWT `+ auth_token
           }
      })
      .then(response => {
             if(response.status >= 400){
                  //throw new Error("bad response from server")
             }

             //console.log("***** read token="+JSON.stringify(response.json()));  // THIS BREAKS CODE! WHY?
             return response.json();
          })
          .then(data => {
             return data;
          });
      // BAD!!! CAN'T DO IT HERE!
      // store session access token
      //console.log("***** access_token="+JSON.stringify(result));
      //var token = result.token;
      //localStorage.setItem('jwt_token', token);
      
      return result;
}



/*
 * VERIFY ACCESS TOKEN
 * TODO: TEST CODE ONLY - DELETE FOR PRODUCTION
 */
export function VerifyToken(token, options) {
   var url=REST_API_SERVER+"/verify/"
   const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "x-requested-with": "xmlhttprequest",
            "Access-Control-Allow-Origin": "*"    // must not have comma!!!
        }

   if (token) {
        headers['Authorization'] = 'JWT ' + token
   }

   var result = fetch(url, {
                      method: "GET",
                      headers,
                      ...options
                })
                .then(response => {
                   if(response.status >= 400){
                        //throw new Error("bad response from server")
                   }
                   //console.log("VerifyToken resp: "+JSON.stringify(response.json()));
                   return response.json();
                })
                .then(data => {
                   return data;
                });
            return result;
    
};



/*
 * Access User/Caller State
 */
export async function GetKustomerJwt(email) {
    var email1 = encodeURIComponent(email);
    var url = NODE_API_SERVER+"/e/jwt/"+email1;
    var token = await GetCORSRaw(url)
    return(token);
}

